/**
 * Sleep utility function
 *
 * @param   {number}  time        Delay in milliseconds
 *
 * @returns  {Promise}              Promise to be resolved
 */
export default (time) => new Promise(resolve => setTimeout(resolve, time));
